import { makeStyles } from '@material-ui/core'
import { css } from 'styled-components'

export const numberFieldStyle = css`
	width: 100%;
`

export const useStyles = makeStyles((theme) => ({
	adorment: {
		marginBottom: 9,
	},
	label: {
		color: theme?.palette?.primary?.main,
		marginBottom: 4,
		...theme?.typography?.subtitle2,
	},
}))
